import  { useState, useEffect } from 'react';
import Captcha from '../UtilityComponents/Captcha';
import { apiPostComment } from '../../api';

const CommentForm = ({ onCommentSubmit }) => {
    const [username, setUsername] = useState('Επισκέπτης');
    const [comment, setComment] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const [hp, setHp] = useState('');
    let [storedUser, setStoredUser] = useState(null);
    useEffect(() => {
        storedUser = localStorage.getItem('loggedInUser');
        setStoredUser(storedUser);
     }, [storedUser]);



    const handleSubmit = async (event) => {
        event.preventDefault();
        const currentDate = new Date();
const formattedTimestamp = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()} ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
console.log(formattedTimestamp);
        const formData = {
            username: username,
            comment: comment,
            timestamp: formattedTimestamp,
            hp: hp
        };

       if(formData.hp){
        return
       }

    
        try {
            await apiPostComment(username, comment, formattedTimestamp);
            onCommentSubmit();
        } catch (error) {
            console.error('Error submitting comment:', error);
        }
    };

    return (
        <form className="cform" onSubmit={handleSubmit}>
            <label className="cform-label">
                Username:
                <input className="cform-input" type="text" value={storedUser?storedUser:username} onChange={(e) => setUsername(e.target.value)} required />
            </label>
            <label className="cform-label">
                Σχόλιο:<br/>
                <textarea className="cform-textarea" value={comment} onChange={(e) => setComment(e.target.value)} required />
            </label>
            <label style={{display: 'none'}}>
                <input type="text" value={hp} onChange={(e) => setHp(e.target.value)} />
            </label>    
            <Captcha onVerify={() => setIsVerified(true)} />
            <button className="cform-submit" type="submit" disabled={!isVerified}>{!isVerified? "👀⏳🥱":"Submit"}</button>
        </form>
    );
};

export default CommentForm;

